export const paths = {
    playbookDetails: '/playbooks/:playbookId',
    playbookDetailsEU: '/playbooks/eu/:playbookId',
    playlistDetails: '/playlists/:playlistId',
    playlistDetailsPlaybooks: '/playbooks/playlists/:playlistId',
    playlistDetailsEU: '/playbooks/eu/playlists/:playlistId',
    sharePlaybook: '/share/playbooks/:playbookId',
    sharePlaylist: '/share/playlists/:playlistId',
    ssoLogin: '/ssologin',
    ssoTenantLogin: '/ssologin/:tenantId',
}
